import { useState, useEffect } from 'react';

export const useDpHidden = () => {
	const [showComponent, setShowComponent] = useState(false);

	useEffect(() => {
		const lastShownDate = localStorage.getItem('lastShownDate');
		const currentDate = new Date().toLocaleDateString();

		if (lastShownDate !== currentDate) {
			setShowComponent(true);
			localStorage.setItem('lastShownDate', currentDate);
		}
	}, []);

	return showComponent;
};
